import React from 'react';
import { Navigate } from 'react-router-dom';

// Control.js has been merged into OrgasmControl.js — redirect for backwards compatibility
function Control() {
  return <Navigate to="/orgasm-control" replace />;
}

export default Control;
